const { USER_PASSWORD_DOES_NOT_MATCH } = require('./codes/errorCodes');

/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    USER_PASSWORD_DOES_NOT_MATCH: {
        code: USER_PASSWORD_DOES_NOT_MATCH.code,
        description: 'User entered wrong password.',
    },
    ENTITY_NOT_FOUND: {
        code: 'ENTITY_NOT_FOUND',
        description: 'Entity was not found in the database.',
    },
    FAKTUROID_ERROR: {
        code: 'FAKTUROID_ERROR',
        description: `Fakturoid some error. It is not possible to generate invoice now.`,
    },
    ENTITY_NOT_EXIST_IN_OFFICE: {
        code: 'ENTITY_NOT_EXIST_IN_OFFICE',
        description: 'Entity was not found as relation with the office.',
    },
    COUNTRY_SHOULD_BE_ASSIGNED_PAYMENT_METHOD: {
        code: 'COUNTRY_SHOULD_BE_ASSIGNED_PAYMENT_METHOD',
        description: 'Requested country should be assigned payment methods.',
    },
    DUPLICITY: {
        code: 'DUPLICITY',
        description: 'This record already exists in a database.',
    },
    INVALID_ISO_COUNTRY_CODE: {
        code: 'INVALID_ISO_COUNTRY_CODE',
        description: 'Requested country code is not valid ISO 3166-1 alpha-2 code.',
    },
    INVALID_CURRENCY_CODE: {
        code: 'INVALID_CURRENCY_CODE',
        description: 'Requested currency code is not valid for any country.',
    },
    INVALID_PHONE_NUMBER: {
        code: 'INVALID_PHONE_NUMBER',
        description: 'Phone number does not have a correct format.',
    },
    INVALID_HEXADECIMAL_COLOR: {
        code: 'INVALID_HEXADECIMAL_COLOR',
        description: 'Requested color is not valid.',
    },
    INPUT_FIELD_VALUE_TOO_SHORT: {
        code: 'INPUT_FIELD_VALUE_TOO_SHORT',
        description: 'Text is too short.',
    },
    INPUT_FIELD_VALUE_TOO_LONG: {
        code: 'INPUT_FIELD_VALUE_TOO_LONG',
        description: 'TExt is too long.',
    },
    INVALID_INPUT: {
        code: 'INVALID_INPUT',
        description: 'Invalid input',
    },
    INVALID_URL_FORMAT: {
        code: 'INVALID_URL_FORMAT',
        description: 'Invalid link format',
    },
    INVALID_EMAIL_FORMAT: {
        code: 'INVALID_EMAIL_FORMAT',
        description: 'Must be a valid email',
    },
    FIELD_MUST_BE_CHECKED: {
        code: 'FIELD_MUST_BE_CHECKED',
        description: 'Field must be checked',
    },
    DB_VALIDATION_ERROR: {
        code: 'DB_VALIDATION_ERROR',
        description: 'Unknown database validation error.',
    },
    DB_ERROR: {
        code: 'DB_ERROR',
        description: 'Unknown database error.',
    },
    RABBIT_QUEUE_IS_DOWN: {
        code: 'RABBIT_QUEUE_IS_DOWN',
        description: 'Rabbit queue is down.',
    },
    EXPIRED_JWT_TOKEN: {
        code: 'EXPIRED_JWT_TOKEN',
        description: 'Token has expired.',
    },
    EMPTY_PRICING_OPTIONS: {
        code: 'EMPTY_PRICING_OPTIONS',
        description: 'At least one pricing option is required for lecture',
    },
    LECTURE_INSTANCE_NOT_DRAFT: {
        code: 'LECTURE_INSTANCE_NOT_DRAFT',
        description: 'Lecture instance is not in draft status.',
    },
    LECTURE_INSTANCE_REQUIRED_FIELDS_MISSING: {
        code: 'LECTURE_INSTANCE_REQUIRED_FIELDS_MISSING',
        description: 'Lecture instance should have place id and employee id filled before publishing.',
    },
    CLIENT_MANAGED_BY_HIMSELF: {
        code: 'CLIENT_MANAGED_BY_HIMSELF',
        description: 'Requested organisation client is managed by himself and cannot be updated by others.',
    },
    USER_ALREADY_CLIENT_OF_THE_OFFICE: {
        code: 'USER_ALREADY_CLIENT_OF_THE_OFFICE',
        description: 'User with fyooga account is already a member of organisation office.',
    },
    THE_PAY_ERROR: {
        code: 'THE_PAY_ERROR',
        description: 'Payment gateway error.',
    },
    USER_ALREADY_EMPLOYEE_OF_THE_OFFICE: {
        code: 'USER_ALREADY_EMPLOYEE_OF_THE_OFFICE',
        description: 'User with fyooga account is already an employee of organisation office.',
    },
    OFFICE_DOES_NOT_ALLOW_UNREGISTERED_RESERVATIONS: {
        code: 'OFFICE_DOES_NOT_ALLOW_UNREGISTERED_RESERVATIONS',
        description:
            "Office doesn't allow in config option to reserve lecture without beeing registered user of this office.",
    },
    OFFICE_DOES_NOT_ALLOW_MORE_RESERVATIONS: {
        code: 'OFFICE_DOES_NOT_ALLOW_MORE_RESERVATIONS',
        description: "Office doesn't allow more reservations than specified.",
    },
    REQUESTED_ASSET_DOES_NOT_BELONG_TO_USER: {
        code: 'REQUESTED_ASSET_DOES_NOT_BELONG_TO_USER',
        description:
            "User is requesting some action on asset which doesn't belong to his account, office client or organisation client (like cancel reservation, delete order, etc.)",
    },
    NO_ACTIONS_AFTER_TERM_STARTED: {
        code: 'NO_ACTIONS_AFTER_TERM_STARTED',
        description:
            'User is requesting some action which is forbidden to do after lecture term is started (like cancel reservation, delete term, etc.)',
    },
    CAN_NOT_CANCEL_RESERVATION: {
        code: 'CAN_NOT_CANCEL_RESERVATION',
        description: 'Reservation can not be canceled for some reason (example: benefit in penalty zone)',
    },
    CALENDAR_SETTINGS_LIMIT_CAN_NOT_CANCEL_RESERVATION: {
        code: 'CALENDAR_SETTINGS_LIMIT_CAN_NOT_CANCEL_RESERVATION',
        description: 'Reservation can not be canceled because deadline for canceling a reservation passed',
    },
    CALENDAR_SETTINGS_LIMIT_CAN_NOT_CREATE_RESERVATION: {
        code: 'CALENDAR_SETTINGS_LIMIT_CAN_NOT_CREATE_RESERVATION',
        description: 'Reservation can not be canceled because deadline for creating a reservation passed',
    },
    CALENDAR_SETTINGS_LIMIT_RESERVATION_NOT_OPEN_YET: {
        code: 'CALENDAR_SETTINGS_LIMIT_RESERVATION_NOT_OPEN_YET',
        description: 'Reservation can not be canceled because reservation are not possible yet',
    },
    RESERVED_FRONTEND_URL_PATH: {
        code: 'RESERVED_FRONTEND_URL_PATH',
        description: 'This URL path is reerved and cannot be used as studio URL',
    },
    ONLY_ONCE_ON_WAITLIST: {
        code: 'ONLY_ONCE_ON_WAITLIST',
        description: 'User can be on waitlist only once',
    },
    LECTURE_TERM_IS_CANCELED: {
        code: 'LECTURE_TERM_IS_CANCELED',
        description: `It is not possible to update canceled term.`,
    },
    STRIPE_ACCOUNT_ID_INVALID: {
        code: 'STRIPE_ACCOUNT_ID_INVALID',
        description: `Fyooga does not have access to account (or that account does not exist). Application access may have been revoked.`,
    },
    STRIPE_ZERO_DECIMAL_ERROR: {
        code: 'STRIPE_ZERO_DECIMAL_ERROR',
        description: `Something went wrong with an amount to be charged.`,
    },
    INVALID_CAPTCHA: {
        code: 'INVALID_CAPTCHA',
        description: `Captcha was not verified successfully`,
    },
    TARIFF_CANNOT_BE_UPDATED: {
        code: 'TARIFF_CANNOT_BE_UPDATED',
        description: `This tariff cannot be canceled.`,
    },
    TARIFF_CANNOT_BE_UPGRADED: {
        code: 'TARIFF_CANNOT_BE_UPGRADED',
        description: `It is not possible to upgrade from your current tariff to requested.`,
    },
    CLIENT_ORDER_ALREADY_PAID: {
        code: 'CLIENT_ORDER_ALREADY_PAID',
        description: `Client order has been paid already.`,
    },
    LICENSE_TARIFF_NOT_ACTIVE: {
        code: 'LICENSE_TARIFF_NOT_ACTIVE',
        description: 'Tariff is expired.',
    },
    WORKSHOP_START_IN_PAST: {
        code: 'WORKSHOP_START_IN_PAST',
        description: 'Workshop start is in the past.',
    },
    WORKSHOP_IS_CANCELED: {
        code: 'WORKSHOP_IS_CANCELED',
        description: 'Workshop is canceled.',
    },
    COURSE_START_IN_PAST: {
        code: 'COURSE_START_IN_PAST',
        description: 'Course already started.',
    },
    COURSE_IS_CANCELED: {
        code: 'COURSE_IS_CANCELED',
        description: 'Course is canceled.',
    },
    TARIFF_LIMIT_REACHED: {
        code: 'TARIFF_LIMIT_REACHED',
        description: 'TARIFF_LIMIT_REACHED.',
    },
    INVALID_PROMO_VOUCHER_CODE: {
        code: 'INVALID_PROMO_VOUCHER_CODE',
        description: 'promo code or voucher provided is not valid',
    },
    ALREADY_EXISTS: {
        code: 'ALREADY_EXISTS',
        description: 'create: entity already exists',
    },
    PROMO_CODE_ALREADY_USED: {
        code: 'PROMO_CODE_ALREADY_USED',
        description: 'promo code was already once used by client or email',
    },
    PROMO_CODE_NOT_FOR_LECTURE: {
        code: 'PROMO_CODE_NOT_FOR_LECTURE',
        description: 'promo code not for lecture',
    },
    PROMO_CODE_NOT_FOR_WORKSHOP: {
        code: 'PROMO_CODE_NOT_FOR_WORKSHOP',
        description: 'promo code not for workshop',
    },
    PROMO_CODE_NOT_FOR_COURSE: {
        code: 'PROMO_CODE_NOT_FOR_COURSE',
        description: 'promo code not for courses',
    },
    PROMO_CODE_NOT_FOR_BUNDLE: {
        code: 'PROMO_CODE_NOT_FOR_BUNDLE',
        description: 'promo code not for bundles',
    },
    VOUCHER_USER_ID_IS_INCORRECT: {
        code: 'VOUCHER_USER_ID_IS_INCORRECT',
        description: 'requesting user id doesnt correspond to claimed user',
    },
    VOUCHER_ALREADY_CLAIMED: {
        code: 'VOUCHER_ALREADY_CLAIMED',
        description: 'Voucher is already claimed',
    },
    VOUCHER_ONLY_CASH_PRICING_ALLOWED: {
        code: 'VOUCHER_ONLY_CASH_PRICING_ALLOWED',
        description: 'Voucher can be use donly with cash pricing options',
    },
    VOUCHER_EXPIRED: {
        code: 'VOUCHER_EXPIRED',
        description: 'Voucher expired',
    },
    VOUCHER_ORDER_NOT_PAID: {
        code: 'VOUCHER_ORDER_NOT_PAID',
        description: 'Voucher not paid yet, cant be claimed',
    },
    VOUCHER_CODE_INVALID: {
        code: 'VOUCHER_CODE_INVALID',
        description: 'Invalid voucher code',
    },
    SUMMARY_MESSAGE_MAX_LIMIT: {
        code: 'SUMMARY_MESSAGE_MAX_LIMIT',
        description: 'Voucher is already claimed',
    },
};
